import React, { Component } from 'react';
import Comment from '../../../../common/comments/comment.component';
import { MAX_LENGTH } from '../../../../../constants/external-constants';
import { Loading } from '../../../../common/loading';
import { connect } from 'react-redux';
import { bindActionCreators } from '@reduxjs/toolkit';
import { contractActions } from '../../../../../store/external/finance/contract.reducer';

class ContractComment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true
        }
    }

    componentDidMount() {
        const { getContractComments, contract} = this.props;
        getContractComments(this.props.financeContractID, contract?.pageIndex, 5, false)
            .then(() => {
                this.setState({ isLoading: false })
            });
    }

    postComment = async (attachedFilename, attachedFileData, commentDescription) => {
        const { postContractComments } = this.props;
        await postContractComments(this.props.financeContractID, attachedFilename, attachedFileData, commentDescription);
    }

    handleDeleteContractComments = async (financeContractID) => {
        this.setState({ isLoading: true });
        const { deleteContractComments, getContractComments, resetContractComments, contract } = this.props;
        await deleteContractComments(financeContractID, this.props.financeContractID);
        await resetContractComments()
        await getContractComments(this.props.financeContractID, 1, contract?.contractComments?.length).then(() => {
            this.setState({ isLoading: false })
        });
        this.setState({ show: false })
    }

    handleLoadMore = async () =>{
        const {getContractComments, contract } = this.props;
        await getContractComments(this.props.financeContractID, contract.pageIndex + 1)
    }

    componentWillUnmount(){
        const { resetContractComments } = this.props;
        resetContractComments();
    }
    render() {
        const { contractComments } = this.props.contract;
        if (this.state.isLoading) {
            return <Loading />
        }

        return (
            <div>
                <Comment
                    commentList={contractComments}
                    addCommentAction={this.postComment}
                    deleteCommentAction={this.handleDeleteContractComments}
                    maxLength={MAX_LENGTH.limit_500}
                    isContractComment={true}
                    handleLoadMore={this.handleLoadMore}
                    hasMoreComments={this.props?.contract?.hasMoreComments}
                    //Access Type
                    isReadOnly={this.props.isReadOnly}
                    isReadAndExtractOnly={this.props.isReadAndExtractOnly}
                    isReadAndWrite={this.props.isReadAndWrite}
                />
            </div>
        );
    }
}

export default connect(
    state => {
        const { contractComments, contract } = state;
        
        return {
            contractComments, contract
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, contractActions),
        dispatch
    )
)(ContractComment);